import React from "react";
import { NoThemeLoader } from "components/layout/ApplicationLoader";

export const CallbackPage = () => <NoThemeLoader />;
